import { Modal } from "@mui/material";
import { useEffect, useState } from "react";

import { Customer, ProductCustomer } from "../../../../../../data/entities";
import CustomTable from "../../../../../../shared/components/CustomTable";
import SearchBarWithSuggestion from "../../../../../../shared/components/SearchBar/SearchBarWithSuggestion";
import { api } from "../../../../../../shared/hooks/api";
import { StyledButton } from "../../../../../../shared/styled/TitleBar";
import { ProductCustomerColumns } from "../../../../../../configs/products";
import { ProductCustomerRow } from "..";
import {
    ButtonRow,
    Expandable,
    InfoText,
    ModalWrapper,
    StyledBackdrop,
    TitleText,
    TitleWrapper,
} from "../../MaterialStandard/AddMaterialModal/Styled";

interface AddProductCustomerModalProps {
    selectedCustomers: ProductCustomer[];
    defaultPrice: number;
    open: boolean;
    handleClose: () => void;
    mergeProduct: Function;
}

export const AddProductCustomerModal = ({
    selectedCustomers,
    defaultPrice,
    open,
    handleClose,
    mergeProduct,
}: AddProductCustomerModalProps) => {
    const [isOpen, setIsOpen] = useState(open);
    const [{ data }, fetchCustomers] = api.get(
        `/customers?page_size=${Number.MAX_SAFE_INTEGER}`,
        undefined,
        true,
    );
    const [selectedItems, setSelectedItems] =
        useState<ProductCustomer[]>(selectedCustomers);
    const customers = data?.results ?? [];

    const removeSelectedItem = (target: ProductCustomer) => {
        setSelectedItems((current) =>
            current.filter((item) => item.customer.id !== target.customer.id),
        );
    };

    const updateCustomerPrice = (target: ProductCustomer, price: number) => {
        setSelectedItems((current) =>
            current.map((item) =>
                item.customer.id === target.customer.id
                    ? { ...item, price }
                    : item,
            ),
        );
    };

    const handleSelectCustomer = (customer: Customer, isAdded: boolean) => {
        const existing = selectedItems.some(
            (item) => item.customer.id === customer.id,
        );
        if (isAdded && !existing) {
            setSelectedItems([
                ...selectedItems,
                {
                    customer,
                    price: defaultPrice ?? 0,
                    addons: [],
                } as ProductCustomer,
            ]);
        } else if (!isAdded && existing) {
            setSelectedItems(
                selectedItems.filter((item) => item.customer.id !== customer.id),
            );
        }
    };

    const handleCloseWithAnimation = () => {
        setIsOpen(false);
        setTimeout(handleClose, 200);
    };

    useEffect(() => {
        if (open) {
            setIsOpen(true);
        } else {
            const timer = setTimeout(() => setIsOpen(false), 200);
            return () => clearTimeout(timer);
        }
    }, [open]);

    return (
        <Modal
            open={open}
            onClose={handleCloseWithAnimation}
            closeAfterTransition
            BackdropComponent={StyledBackdrop}
            BackdropProps={{ timeout: 500, onClick: (event) => event.stopPropagation() }}
        >
            <ModalWrapper isOpen={isOpen}>
                <Expandable>
                    <TitleWrapper>
                        <TitleText>Thêm khách hàng</TitleText>
                        <InfoText>
                            Chọn khách hàng và điều chỉnh giá bán trước khi lưu
                        </InfoText>
                    </TitleWrapper>
                    <SearchBarWithSuggestion
                        menuList={customers}
                        fetchItems={(variables: any) => fetchCustomers(variables)}
                        selectedItems={selectedItems}
                        handleOnclickItem={handleSelectCustomer}
                        placeholder="Tìm kiếm theo mã hoặc tên khách hàng"
                    />
                    <CustomTable
                        itemList={selectedItems}
                        RowElement={ProductCustomerRow}
                        TableColumns={ProductCustomerColumns}
                        extraRowProps={{
                            removeItem: removeSelectedItem,
                            updateCustomerPrice,
                            canEdit: true,
                        }}
                        containerStyle={{ maxHeight: "400px" }}
                    />
                </Expandable>
                <ButtonRow>
                    <StyledButton onClick={handleCloseWithAnimation}>
                        Huỷ bỏ
                    </StyledButton>
                    <StyledButton
                        variant="contained"
                        onClick={() => {
                            mergeProduct({ customers: selectedItems });
                            handleClose();
                        }}
                    >
                        Lưu khách hàng
                    </StyledButton>
                </ButtonRow>
            </ModalWrapper>
        </Modal>
    );
};
